import { render, staticRenderFns } from "./CreateNewDele.vue?vue&type=template&id=97cd5df8&scoped=true&"
import script from "./CreateNewDele.vue?vue&type=script&lang=js&"
export * from "./CreateNewDele.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewDele.vue?vue&type=style&index=0&id=97cd5df8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cd5df8",
  null
  
)

export default component.exports